import { BRAND } from "@/config/brand";
const C = BRAND.colors;
const teal = "#14B8A6";
const gold = "#FFD700";

const MESSAGES = [
  "Don't let AI pass you by",
  "The time is NOW — not to talk about it",
  "NO templates. Ever.",
  "$125 redesigns to $2,500 full websites",
  "Average site: $600",
  "Transparent. No smoke. Just what it takes to play in 2026",
];

// Repeating ticker/marquee — infinite scroll, respects prefers-reduced-motion.
export default function KitTicker() {
  const items = Array(3).fill(null).flatMap(() => MESSAGES);
  return (
    <div
      className="relative w-full overflow-hidden border-y"
      style={{
        borderColor: `${teal}44`,
        background: `linear-gradient(90deg, rgba(20,184,166,0.14) 0%, rgba(10,15,30,0.9) 40%, rgba(10,15,30,0.9) 60%, rgba(255,215,0,0.10) 100%)`,
      }}
      data-testid="kit-ticker"
    >
      <div className="flex items-center py-3 whitespace-nowrap animate-[ticker_36s_linear_infinite] gap-10 md:gap-14">
        {items.map((m, i) => (
          <span key={i} className="flex items-center gap-3 shrink-0">
            <span
              className="w-2 h-2 rounded-full animate-pulse"
              style={{ background: i % 2 === 0 ? teal : gold, boxShadow: `0 0 10px ${i % 2 === 0 ? teal : gold}` }}
            />
            <span
              className={`text-sm md:text-base font-black uppercase tracking-[0.2em] ${i % 3 === 0 ? "gold-shine gold-shine-dark" : ""}`}
              style={i % 3 !== 0 ? { color: i % 2 === 0 ? teal : "white" } : undefined}
            >
              {m}
            </span>
          </span>
        ))}
      </div>
      <style>{`
        @keyframes ticker {
          from { transform: translateX(0); }
          to   { transform: translateX(-50%); }
        }
        @media (prefers-reduced-motion: reduce) {
          [data-testid="kit-ticker"] > div { animation: none; }
        }
      `}</style>
    </div>
  );
}
